import { Modal, Card } from "@mui/material";
import Button from "@mui/material/Button";
import "../css/Override.scss";
import "./NewGameModal.scss";
import { useTranslation } from "react-i18next";
import AllDataClass from "../common/AllDataClass";
import { uniqueNamesGenerator, Config, adjectives, colors, animals } from "unique-names-generator";

import { useState } from "react";

const config: Config = {
  separator: "-",
  dictionaries: [adjectives, colors, animals],
};

type ModalProp = {
  open: boolean;
  handleClose: () => void;
  handleGo: () => void;
};

const NewGameModal = ({ open, handleClose, handleGo }: ModalProp) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const start = () => {
    if (name.length <= 0) {
      alert(t("alert-input-name"));
      return;
    }
    var key = uniqueNamesGenerator(config);
    AllDataClass.setUserName(name);
    AllDataClass.setGameId(key);
    handleGo();
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="newgame-modal-main"
      >
        <div className="newgame-modal-content">
          <div className="modal-title">{t("brief")}</div>
          <div className="modal-explanation">
            <div className="modal-explanation-text">
              {t("brief-detail")
                .split("\n")
                .map((item: any, idx: any) => (
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                ))}
            </div>
          </div>
          <div className="modal-inputname">
            {/* {t("input-name")} */}
            <input
              type="text"
              placeholder={t("input-name-here")}
              onChange={(e) => setName(e.target.value)}
              // onKeyDown={(e) => {
              //   e.key === "Enter" && start;
              // }}
            />
            <button onClick={start}>{t("play")}</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default NewGameModal;
